import { Toaster } from "react-hot-toast";
import "./App.css";
import Router from "./routes/routes";
import ErrorBoundary from "./components/Errorboundary";
import { useEffect } from "react";
import { useSelector } from "react-redux";

function App() {
  //for chnage favicon icon daynamic
  const { selectedCompany } = useSelector((state) => state?.auth);
  useEffect(() => {
    if (selectedCompany) {
      // Change the favicon dynamically
      const link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = selectedCompany?.logo;
      document.getElementsByTagName("head")[0].appendChild(link);
    }
  }, [selectedCompany]);
  // remove all console
  useEffect(() => {
    const originalConsoleLog = console.log;
    const originalConsoleWarn = console.warn;
    const originalConsoleError = console.error;

    console.log = console.warn = console.error = () => {};

    return () => {
      console.log = originalConsoleLog;
      console.warn = originalConsoleWarn;
      console.error = originalConsoleError;
    };
  }, []);
  return (
    <>
      <ErrorBoundary>
        <Router />
        <Toaster position="top-right" />
      </ErrorBoundary>
    </>
  );
}

export default App;
